<template>
  <div>
    <title>购买方管理</title>
    <TradingRoleInfo :roleType='0'></TradingRoleInfo>
  </div>
</template>
<script>
export default {
  name: 'BuyerList',
  data () {
    return {
    }
  },
  components: {
    TradingRoleInfo: resolve => require(["@/components/InvoiceManage/TradingRoleInfo.vue"], resolve),// 购买方/销售方列表组件
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/OrderFolder/InvoiceManage/BuyerList.vue